import dev_config from "./dev_config";
import beta_config from "./beta_config";
import prod_config from "./prod_config";
export let config = dev_config;

function timeout(ms, promise) {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      reject(new Error("timeout"));
    }, ms);
    promise.then(resolve, reject);
  });
}

export async function loadAppConfig() {
  console.log("[Fetch Config]start async call");
  let stage = {stage:"beta"};
  try {
    stage = await timeout(
      1000,
      fetch(`/config/config.json`).then((response) => response.json())
    );
  } catch (e) {
    stage = { stage: "dev" };
  }
  console.log(`Fetch Config loaded config=${JSON.stringify(stage)}`);
  switch (stage.stage) {
    case "beta":
      config = beta_config;
      break;
    case "prod":
      config = prod_config;
      break;
    default:
      config = beta_config;
      break;
  }
  return config;
}